import React from 'react'
import { Stack } from '@pet-notify/ui'

import visaIcon from './images/visa-icon.png'
import masterCardIcon from './images/mastercard-icon.png'
import americanExpressIcon from './images/americanexpress-icon.png'
import discoverIcon from './images/discover-icon.png'
import style from './style.module.css'

function PaymentMethodIcons() {
  return (
    <Stack as='ul' mb='8' direction='horizontal' spacing='4'>
      <li>
        <img src={visaIcon} alt='Visa' height='34' />
      </li>
      <li>
        <img src={masterCardIcon} alt='Mastercard' height='34' />
      </li>
      <li>
        <img src={americanExpressIcon} alt='American Express' height='34' />
      </li>
      <li>
        <img src={discoverIcon} alt='Discover' height='34' />
      </li>
      <li className={style.secureMessage}>Secure Payment</li>
    </Stack>
  )
}

export default PaymentMethodIcons
